import { useReducer, useRef } from 'react'
import Webcam from 'react-webcam'
import { photoCaptureReducer } from '../utilities/photoCaptureReducer'
import { initialState } from '../utilities/initialValues'

const usePhotoCapture = () => {
    const webcamRef = useRef<Webcam>(null)
    const [state, dispatch] = useReducer(photoCaptureReducer, initialState)
    const { photo, isUploading, error } = state

    const capturePhoto = () => {
        if (webcamRef.current) {
            const imageSrc = webcamRef.current.getScreenshot()
            if (imageSrc) {
                dispatch({ type: 'SET_IMAGE_SOURCE', payload: imageSrc })
            }
        }
    }

    const retakePhoto = () => {
        dispatch({ type: 'SET_IMAGE_SOURCE', payload: null })
        dispatch({ type: 'SET_ERROR', payload: null })
    }

    const setUploading = (isUploading: boolean) => {
        dispatch({ type: 'SET_IS_UPLOADING', payload: isUploading })
    }

    const setError = (error: string | null) => {
        dispatch({ type: 'SET_ERROR', payload: error })
    }

    return {
        webcamRef,
        photo,
        isUploading,
        error,
        capturePhoto,
        retakePhoto,
        setUploading,
        setError,
    }
}

export default usePhotoCapture
